import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import {enableScroll, disableScroll} from '../services/Scroll'
import { focusTrap } from '../utils/focus'

const STATES = {
    OPEN: 'is-open',
    READY: 'is-ready'
}

export default class PopupNav extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            header: null
        }

        this.categories = [...this.element.querySelectorAll('[data-category]')].map(element => ({
            element,
            categoryId: element.dataset.category,
            backCategoryId: element.dataset.categoryBack,
            backText: element.dataset.categoryBackText,
        }))

        this.lastCaller = null
        this.lastCategoryId = null
        this.timer = null
    }

    prepare() {
        EventBus.on(EVENTS.POPUPNAV_SETCATEGORY, this.handlePopupNavSetCategory)
        EventBus.on(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
        EventBus.on(EVENTS.POPUPNAV_OPEN, this.handlePopupNavOpen)
        EventBus.on(EVENTS.POPUPNAV_CLOSE, this.handlePopupNavClose)

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.element.classList.add(STATES.READY)
           })
        })
    }

    destroy() {
        clearTimeout(this.timer)
        EventBus.off(EVENTS.POPUPNAV_SETCATEGORY, this.handlePopupNavSetCategory)
        EventBus.off(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
        EventBus.off(EVENTS.POPUPNAV_OPEN, this.handlePopupNavOpen)
        EventBus.off(EVENTS.POPUPNAV_CLOSE, this.handlePopupNavClose)
    }

    handlePopupNavToggle = () => {
        this.toggle()
    }

    handlePopupNavOpen = (options) => {
        this.open(options)
    }

    handlePopupNavClose = () => {
        this.close()
    }

    handlePopupNavSetCategory = ({ categoryId }) => {
        this.setCategory(categoryId)
    }

    handleDocumentKeyUp = (event) => {
        if (event.key === 'Escape') {
            this.closeImmediately()
        }
    }

    //nastavit is-active na kategorii + vsechny, ktery sou nadrazeny (resp. vsechny .backCategoryId)
    setCategory(categoryId) {
        if (this.lastCategoryId === categoryId) {
            return
        }

        const getSupercategories = (category, supercategories = []) => {
            if (!category.backCategoryId) {
                return supercategories
            }

            const backCategory = this.categories.find(_category => _category.categoryId === category.backCategoryId)
            if (backCategory) {
                supercategories.push(backCategory)
            }
            return getSupercategories(backCategory, supercategories)
        }

        const activeCategories = []
        this.categories.forEach(category => {
            if (categoryId && category.categoryId === categoryId) {
                category.element.classList.add('is-active')
                activeCategories.push(category)
            } else {
                category.element.classList.remove('is-active')
            }
            category.element.classList.remove('is-super')
        })
        activeCategories.forEach(activeCategory => {
            const supercategories = getSupercategories(activeCategory)
            supercategories.forEach(superCategory => {
                superCategory.element.classList.add('is-active', 'is-super')
            })
        })

        this.lastCategoryId = categoryId
        this.updateBackButton()
        EventBus.emit(EVENTS.POPUPNAV_CATEGORYCHANGED, { categoryId })
    }

    updateBackButton() {
        const category = this.categories.find(category => category.categoryId === this.lastCategoryId)
        if (!category) {
            return
        }
        this.ref.header.innerHTML = category.backCategoryId ? `<button data-popupnav-category="${category.backCategoryId}">${category.backText}</button>` : ``
    }

    open(options) {
        this.lastCaller = options?.caller
        clearTimeout(this.timer)
        this.timer = null

        if (this.is(STATES.OPEN)) {
            return
        }

        document.addEventListener('keyup', this.handleDocumentKeyUp)

        this.element.classList.add(STATES.OPEN)
        EventBus.emit(EVENTS.POPUPNAV_OPENED)
        disableScroll()
        
        this.focusTrap = focusTrap(this.element)
        this.focusTrap.init()

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.element.classList.add('has-transition')
            })
        });
    }

    close() {
        if (this.timer) {
            return
        }

        this.timer = setTimeout(() => {
            this.closeImmediately()
            this.timer = null
        }, 1000)
    }

    toggle() {
        if (!this.is(STATES.OPEN) || this.timer) {
            this.open()
        } else {
            this.closeImmediately()
        }
    }

    closeImmediately() {
        clearTimeout(this.timer)
        this.timer = null
        document.removeEventListener('keyup', this.handleDocumentKeyUp)
        this.element.classList.remove(STATES.OPEN)
        EventBus.emit(EVENTS.POPUPNAV_CLOSED)
        enableScroll()

        this.focusTrap?.destroy()


        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.element.classList.remove('has-transition')
            })
        });
    }
}